import _ from 'lodash'

const throttleHandler = resizeHandler => _.throttle(resizeHandler, 500, {leading: false, trailing: true})

module.exports = {
    throttleHandler
}
